import { propertyHomeTypeMap } from "@/utils";
import formatAddress from "@/utils/propertyAddress";
import { getMetaDescription } from "@/utils/seoParser";

const seoData = {
  homepage: {
    title: "Homes Globe | AI-Powered Global Real Estate Platform",
    description:
      "Buy, sell, or rent properties across 100+ countries. Homes Globe connects you with verified listings and trusted sellers around the world.",
    keywords:
      "global real estate, buy property abroad, sell home, rent house, international property listings, Homes Globe"
  },
  search: {
    title: "Search Properties Worldwide | Homes Globe",
    description:
      "Find homes and real estate investments worldwide with Homes Globe. Use advanced filters and map view to explore thousands of listings.",
    keywords:
      "property search, international real estate, global homes, luxury listings, real estate map search, Homes Globe listings"
  },
  propertyDetail: {
    title: ({ name, address }) =>
      `${name} | ${formatAddress(address)} | Homes Globe`,
    description: (property) => getMetaDescription(property),
    keywords: ({ propertyHomeType, address }) =>
      `${formatAddress(address)}, property, real estate, ${
        propertyHomeTypeMap[propertyHomeType]
      }, property for sale,property for rent, Homes Globe listing`
  },
  about: {
    title: "About Homes Globe | Global Real Estate Hub",
    description:
      "Homes Globe is a Dubai-based platform that simplifies cross-border real estate transactions. Powered by cutting-edge technology and trusted partnerships.",
    keywords:
      "Homes Globe, real estate platform, international real estate, Dubai proptech, Microsoft startup, global property portal"
  },
  contact: {
    title: "Contact Homes Globe | Get in Touch",
    description:
      "Reach out to the Homes Globe team for support, partnership inquiries, or general questions. We're here to help.",
    keywords:
      "contact Homes Globe, support, real estate help, global real estate platform contact"
  }
};

export default seoData;
